module.exports = __webpack_public_path__ + "static/img/1000000473.b8677125.jpg";